import { EStudentPaymentStatus } from '@constants';
import { useMemo, useState } from 'react';

import {
  DropdownWrapper,
  OptionsWrapper,
  SelectionWrapper,
  Wrapper
} from './CustomTagSelector.styles';

import { Icon } from '@/components/Icon';
import { StudentPaymentStatusTag } from '@/components/StudentPaymentStatusTag';

type Props = {
  selectedStatus: EStudentPaymentStatus | null;
  setSelectedStatus: (status: EStudentPaymentStatus | null) => void;
};

export const CustomTagSelector: React.FC<Props> = ({ selectedStatus, setSelectedStatus }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectStatus = (status: EStudentPaymentStatus) => {
    setSelectedStatus(status);
    setIsOpen(false);
  };

  const options = useMemo(() => {
    return Object.values(EStudentPaymentStatus).map(status => ({
      value: status,
      label: (
        <StudentPaymentStatusTag
          onClick={() => handleSelectStatus(status)}
          paymentStatus={status}
        />
      )
    }));
  }, []);
  return (
    <Wrapper>
      <SelectionWrapper onClick={() => setIsOpen(!isOpen)}>
        <div>{selectedStatus && <StudentPaymentStatusTag paymentStatus={selectedStatus} />}</div>
        <Icon i="ChevronDown" />
      </SelectionWrapper>
      {isOpen && (
        <DropdownWrapper>
          <OptionsWrapper>
            {options.map(option => (
              <div key={option.value} onClick={() => handleSelectStatus(option.value)}>
                {option.label}
              </div>
            ))}
          </OptionsWrapper>
        </DropdownWrapper>
      )}
    </Wrapper>
  );
};
